var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css.boxGallery},[(_vm.box.type === 'article')?_c('GalleryHero',{attrs:{"gallery":_vm.gallery},on:{"click":_vm.handleClick}}):_c('GallerySlider',{attrs:{"gallery":_vm.gallery.gallery}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }